import React from "react";
import { HazardMarkerType, useData } from "../contexts/DataContext";
import RouteColorSwatch from "../../Maps/ActiveRoutes/RouteColorSwatch";
import { normalizeSiteMapColor } from "../utils/colors";
import MapRouteSidebar, { MapRouteDelete } from "../components/MapRouteSidebar";

// this route only is shown / operates in editing mode
const SiteMapHazardRoute = ({
  hazard,
}: {
  hazard: HazardMarkerType | undefined;
}) => {
  return <>{!hazard ? <NoHazardFound /> : <EditHazardDetails hazard={hazard} />}</>;
};

export default SiteMapHazardRoute;

const HazardWrapper = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  return <MapRouteSidebar title={title}>{children}</MapRouteSidebar>;
};

const NoHazardFound = () => {
  return (
    <HazardWrapper title="No Hazard">
      <div style={{ color: "red" }}>No hazard selected</div>
    </HazardWrapper>
  );
};

const EditHazardDetails = ({
  hazard,
}: {
  hazard: HazardMarkerType;
}): JSX.Element => {
  const { deleteHazardMarker, updateHazardMarker } = useData();

  const handleHazardColorChange = (color: string) => {
    updateHazardMarker({ ...hazard, color });
  };

  return (
    <>
      <HazardWrapper title="Edit Hazard">
        <div>
          <label
            htmlFor="color"
            style={{ display: "block", marginBottom: "5px" }}
          >
            Color
          </label>
          <RouteColorSwatch
            size="lg"
            placement="left"
            color={normalizeSiteMapColor(hazard.color, "red")}
            onChange={handleHazardColorChange}
            testId="hazard-color-swatch"
          />
        </div>
        <MapRouteDelete onDelete={() => deleteHazardMarker(hazard)} />
      </HazardWrapper>
    </>
  );
};
